module.exports = __webpack_public_path__ + "0a6679deed86868efdbb2e2176d085b1.svg";